import { render, staticRenderFns } from "./ModalImageViewer.vue?vue&type=template&id=5128c0bc&scoped=true&"
import script from "./ModalImageViewer.vue?vue&type=script&lang=js&"
export * from "./ModalImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModalImageViewer.vue?vue&type=style&index=0&id=5128c0bc&prod&lang=css&"
import style1 from "./ModalImageViewer.vue?vue&type=style&index=1&id=5128c0bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128c0bc",
  null
  
)

export default component.exports